import { IconComponentProps } from './index'

const NavigationPlatform =  ({ width = 24, height = 24, customClass = '' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={`strokefill ${customClass}`}>
  <path d='M10 3H3V10H10V3Z' stroke='white' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/>
  <path d='M21 3H14V10H21V3Z' stroke='white' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/>
  <path d='M21 14H14V21H21V14Z' stroke='white' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/>
  <path d='M10 14H3V21H10V14Z' stroke='white' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/>
</svg>

export default NavigationPlatform